import { IUsefullContactFilterParams, IUsefullContact } from '../Models';

const headers = new Headers();
headers.append('Accept-Language', document.querySelector('html')!.lang);
headers.append('Content-Type', 'application/json');

export const UsefullContactService = {
    async getAllUsefullContact(
        searchParams: IUsefullContactFilterParams,
        signal?: AbortSignal
    ): Promise<IUsefullContact[]> {
        const response = await fetch('/api/UsefullContacts/GetAll', {
            method: 'POST',
            body: JSON.stringify(searchParams),
            headers,
            signal,
        });
        return await response.json();
    },
    async getAllUsefullContactType(): Promise<string[]> {
        const response = await fetch(
            '/api/UsefullContacts/GetAllUsefullContactType',
            { headers }
        );
        return await response.json();
    },
    async getAllFieldOfSupport(): Promise<string[]> {
        const response = await fetch(
            '/api/UsefullContacts/GetAllFieldsOfSupport',
            { headers }
        );
        return await response.json();
    },
    async getAllUsefullContactTitle(): Promise<string[]> {
        const response = await fetch(
            '/api/UsefullContacts/GetAllUsefullContactTitle',
            { headers }
        );
        return await response.json();
    },
};
